import { ReactNode } from "react";

export type afterSocialLoginSuccess = {
  type: SocialLoginPlatformEnum;
  socialId: string;
  email: string;
  ageRange?: string;
  birthday?: string;
  birthdayType?: 'LUNAR' | 'SOLAR';
  birthYear?: string;
  gender?: 'male' | 'female';
  name?: 'string';
  phoneNumber?: string;
}

export type SocialLoginButtonsProps = {
  afterSocialLoginSuccess: (params: afterSocialLoginSuccess) => void,
  dataSocial: SocialLoginPlatformEnum,
  dbinsurance?: boolean;
}

export type SocialLoginBtnProps = {
  onClick: () => void,
  backgroundColor?: string,
  fontColor?: string,
  additionalStyle?: string,
  icon: ReactNode,
  text: string,
}

export enum SocialLoginPlatformEnum {
  NAVER = 'naver',
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  KAKAO = 'kakao',
  APPLE = 'apple'
}